__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "catalystzero-bv-fe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fluentui/react-hooks", "8.8.16", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(60722))))));
			register("@hookform/resolvers", "3.9.1", () => (Promise.all([__webpack_require__.e(652), __webpack_require__.e(912)]).then(() => (() => (__webpack_require__(76912))))));
			register("@mds/mds-reactjs-library", "2.1.1", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(860), __webpack_require__.e(604)]).then(() => (() => (__webpack_require__(53860))))));
			register("@tanstack/react-query", "5.62.3", () => (Promise.all([__webpack_require__.e(333), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(52333))))));
			register("ajv-errors", "3.0.0", () => (Promise.all([__webpack_require__.e(586), __webpack_require__.e(796), __webpack_require__.e(913)]).then(() => (() => (__webpack_require__(41913))))));
			register("ajv", "8.17.1", () => (Promise.all([__webpack_require__.e(586), __webpack_require__.e(282)]).then(() => (() => (__webpack_require__(63282))))));
			register("axios", "1.7.9", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(84447))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(128).then(() => (() => (__webpack_require__(25128))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(164).then(() => (() => (__webpack_require__(34164))))));
			register("debounce-fn", "6.0.0", () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(78967))))));
			register("luxon", "3.5.0", () => (__webpack_require__.e(285).then(() => (() => (__webpack_require__(96285))))));
			register("qs", "6.13.1", () => (Promise.all([__webpack_require__.e(373), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(55373))))));
			register("rambda", "9.4.0", () => (__webpack_require__.e(917).then(() => (() => (__webpack_require__(42917))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-hook-form", "7.54.0", () => (__webpack_require__.e(785).then(() => (() => (__webpack_require__(49785))))));
			register("react-intl", "7.0.4", () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(85019))))));
			register("react-router-dom", "6.28.0", () => (() => (__webpack_require__(92648))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
			register("recharts", "2.14.1", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(972), __webpack_require__.e(843)]).then(() => (() => (__webpack_require__(88972))))));
			register("streamsaver", "2.0.6", () => (__webpack_require__.e(451).then(() => (() => (__webpack_require__(71451))))));
			register("valtio", "2.1.2", () => (__webpack_require__.e(411).then(() => (() => (__webpack_require__(55411))))));
			initExternal(58053);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};